import React from 'react';
import { Card, CardContent, Typography, Grid, Box, Avatar } from '@mui/material';
import {
    Assignment as AssignmentIcon,
    People as PeopleIcon,
    CheckCircle as CheckCircleIcon,
    Timeline as TimelineIcon
} from '@mui/icons-material';

const DashboardStats = (props) => {
    const { surveys, recentResponses } = props;

    const totalForms = surveys ? surveys.length : 0;
    const totalResponses = recentResponses ? recentResponses.length : 0;
    
    // Calculate unique individuals
    const individuals = recentResponses ? [...new Set(recentResponses.map(r => r.answeredby))] : [];
    const totalIndividuals = individuals.length;

    const stats = [
        {
            title: 'Total Forms',
            value: totalForms,
            icon: <AssignmentIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
            color: 'primary.light'
        },
        {
            title: 'Total Responses',
            value: totalResponses,
            icon: <TimelineIcon sx={{ fontSize: 40, color: 'secondary.main' }} />,
            color: 'secondary.light'
        },
        {
            title: 'Participants',
            value: totalIndividuals,
            icon: <PeopleIcon sx={{ fontSize: 40, color: 'success.main' }} />,
            color: 'success.light'
        },
        {
            title: 'Active Status',
            value: 'Active',
            icon: <CheckCircleIcon sx={{ fontSize: 40, color: 'info.main' }} />,
            color: 'info.light'
        }
    ];

    return (
        <Grid container spacing={3} sx={{ mb: 4 }}>
            {stats.map((stat, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                    <Card elevation={2} sx={{ height: '100%' }}>
                        <CardContent>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Box>
                                    <Typography color="textSecondary" gutterBottom variant="overline">
                                        {stat.title}
                                    </Typography>
                                    <Typography variant="h4" component="div" sx={{ fontWeight: 'bold' }}>
                                        {stat.value}
                                    </Typography>
                                </Box>
                                <Avatar sx={{ bgcolor: stat.color, width: 56, height: 56 }}>
                                    {stat.icon}
                                </Avatar>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
            ))}
        </Grid>
    );
};

export default DashboardStats;
